import "./Homepage.css";
import { useState } from "react";
import Header from "./Header";
import Carousel from "./Carousel";
import Showcase from "./Showcase";

const Homepage = () => {
  const [image, setImage] = useState("");

  const changeImage = (image) => {
    setImage(image);
  };

  return (
    <>
      <Header />
      <Carousel onClick={(chosenImage) => changeImage(chosenImage)} />
      {image === "" && (
        <h1 className="choose-project">
          Kies een project voor meer informatie
        </h1>
      )}
      <Showcase image={image} />
    </>
  );
};

export default Homepage;
